module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "wizardTitlxe"
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addMember.title')))]), _vm._v(" "), _c('el-form', {
    ref: "newMemberForm",
    attrs: {
      "model": _vm.newMemberForm,
      "rules": _vm.newMemberRules
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "12px"
    },
    attrs: {
      "prop": "firstname",
      "show-message": false
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('static.members.index.dialog.addMember.firstName')
    },
    model: {
      value: (_vm.newMemberForm.firstname),
      callback: function($$v) {
        _vm.$set(_vm.newMemberForm, "firstname", $$v)
      },
      expression: "newMemberForm.firstname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "prop": "lastname",
      "show-message": false
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('static.members.index.dialog.addMember.lastName')
    },
    model: {
      value: (_vm.newMemberForm.lastname),
      callback: function($$v) {
        _vm.$set(_vm.newMemberForm, "lastname", $$v)
      },
      expression: "newMemberForm.lastname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "show-message": false
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('static.members.index.dialog.addMember.email')
    },
    model: {
      value: (_vm.newMemberForm.email),
      callback: function($$v) {
        _vm.$set(_vm.newMemberForm, "email", $$v)
      },
      expression: "newMemberForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border": "solid 1px #1bbc9b",
      "color": "#1bbc9b",
      "background-color": "#fff",
      "float": "left"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMember
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.add')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e07c1e38","hasScoped":false}!./src/app/pages/withNavigation/members/create/create.html
// module id = 3131
// module chunks = 1